//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import HelpSection from './_help'
export default {
    data () {
        return {
            show_help: false
        }
    },
    computed: {
        has_status () {
            return this.item.status
        },
        show_help_btn () {
            const { decoration_type, usage } = this.item
            return !((decoration_type === '清水' || decoration_type === '非清水') && usage === '住宅')
        },
        usage_class () {
            return {
                '住宅': 'house',
                '公寓': 'apartment'
            }[this.item.usage]
        },
        decoration_type_class () {
            return {
                '精装': 'decorated',
                '清水': 'original',
                '非清水': 'original'
            }[this.item.decoration_type]
        }
    },
    methods: {
        toggleHelpShow () {
            this.show_help = !this.show_help
        },
        goLoanComputer () {
            this.$router.push({
                path: `/packageA/loan_computer/main?total_price=${this.item.total_price}`
            })
        },
        changeDecorate () {
            if (this.item.show_decorate_select && this.item.show_decorate_price) {
                this.$emit('changeDecorate')
            }
        }
    },
    props: {
        item: {
            type: Object
        },
        type: {
            type: String
        }
    },
    components: {
        HelpSection
    }
}
